<script setup lang="ts">
import MBanner from ".";
import MLayoutStack from "../MLayoutStack";
import MRadioGroup from "../MRadioGroup";
import MCheckbox from "../inputs/MCheckbox";
import MDate from "../inputs/MDate";
import MInput from "../inputs/MInput";
import MRadio from "../inputs/MRadio";
import MSelect from "../inputs/MSelect";
import MTelephoneNumberInput from "../inputs/MTelephoneNumberInput";
</script>
<template>
  <div>
    <m-banner type="info"> Info - Please fill the required fields below </m-banner>
    <hr />
    <m-banner type="warning"> Warning - Please fill the required fields below </m-banner>
    <hr />
    <m-banner type="danger"> Please fill the required fields below </m-banner>
    <hr />
    <m-banner type="success"> Please fill the required fields below </m-banner>
    <hr />
    <m-banner type="system"> Please fill the required fields below </m-banner>
    <hr />

    <m-banner type="system">
      <m-radio-group>
        <m-radio label="test" />
        <m-radio label="other" />
        <m-radio label="ttt" />
      </m-radio-group>
    </m-banner>
    <hr />

    <m-banner>
      <m-layout-stack>
        <m-input />
        <m-select />
        <m-date />
        <m-telephone-number-input />
        <m-radio />
        <m-checkbox />
      </m-layout-stack>
    </m-banner>
    <hr />

    <m-banner :expanded="true" :expand="true" label="Expandable and open"> Content </m-banner>
    <hr />
    <m-banner type="success" :expanded="true" :expand="true" label="Expandable and open">
      Content
    </m-banner>
    <hr />
    <m-banner type="success" :expanded="true" :expand="true" label="Expandable and open">
      Content
    </m-banner>
    <hr />

    <m-banner :expanded="false" :expand="true" label="Expandable and closed"> Content </m-banner>

    <hr />
    <m-banner>
      <p>Multi line checkbox in a banner</p>
      <m-checkbox
        label="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum"
      />
    </m-banner>
  </div>
</template>
